import { render } from "./InputCurrency.vue?vue&type=template&id=0c075cc8&scoped=true"
import script from "./InputCurrency.vue?vue&type=script&lang=ts"
export * from "./InputCurrency.vue?vue&type=script&lang=ts"

import "./InputCurrency.vue?vue&type=style&index=0&id=0c075cc8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0c075cc8"

export default script